export const modalWrapper = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "100%", sm: 500, md: 600 },
  maxHeight: "100%",
  overflowY: "auto",
  p: 2,
}

export const modalBgWrapper = {
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 4,
  backgroundColor: "white",
}

export const modalEmptyWrapper = {
  px: { xs: 2, md: 3, lg: 4 },
  pt: { xs: 2, md: 3, lg: 4 },
  pb: 2,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}

export const modalEmptyText = {
  fontWeight: 600,
  mb: 3,
}

export const modalEmptyButton = {
  width: "100%",
  lineHeight: "2rem",
  fontSize: 20,
  fontWeight: 700,
}

export const modalCloseWrapper = {
  display: "flex",
  pb: { xs: 2, md: 3, lg: 4 },
  justifyContent: "center",
  alignItems: "center",
}

export const modalCloseText = {
  fontSize: 14,
  color: "gray",
  fontStyle: "italic",
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlineOffset: 2,
  "&:hover": {
    color: "blackLighter",
  },
}

export const modalTitleWrapper = {
  padding: { xs: "16px 24px", sm: "16px 30px" },
  backgroundColor: "#E0E0E6",
  borderRadius: "16px 16px 0 0",
}

export const modalTitle = {
  fontSize: { xs: "16px", sm: "24px" },
  color: "#0F171F",
}
